var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"cover"},[_c('img',{attrs:{"src":require(("@/assets/images/" + _vm.image)),"alt":"Logo"}})]),_c('div',{staticClass:"about"},[_vm._v(" "+_vm._s(_vm.about)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }